import dayjs from 'dayjs';
import { Company, LoginReponse } from '../../model/login_response';
import { AreasReponse } from '../../model/areas_response';
import { PermissionName } from '../../valueobject/permissionName';
import { createDI } from '../di/di';
import { BusinessTypeKeys } from '../../constant';

/**
 * セッション情報 状態を管理するための DI コンテキスト
 */
type SessionState = {
  /**
   * ログイン情報
   */
  loginInfo?: LoginReponse;

  /**
   * エリア一覧情報
   */
  areasInfo?: AreasReponse;

  /**
   * 前回表示した街区ID
   */
  selectedDivisionId?: number;

  /**
   * 前回表示したフロアグループID
   */
  selectedFloorGroupId?: number;

  /**
   * 前回表示したフロアID
   */
  selectedFloorId?: number;

  /**
   * セッション存在するか否か
   */
  hasSession: boolean;

  /**
   * 最終ログアウト日時
   */
  logoutTime?: dayjs.Dayjs;
};

/**
 * セッション情報 アクションを管理するための DI コンテキスト(アクション)
 */
type Action = {
  /**
   * ログイン
   * @param login
   */
  login: (login: LoginReponse | undefined) => void;

  /**
   * 権限存在チェック
   * @param permissionName
   * @param requireWrite
   * @param allowBusinessTypes
   */
  hasPermission: (permissionName: PermissionName, requireWrite?: boolean, allowBusinessTypes?: BusinessTypeKeys[]) => boolean;

  /**
   * ログアウト
   */
  logout: () => void;

  /**
   * エリア一覧をセッションに保存
   * @param areas
   */
  setAreaInSession: (areas: AreasReponse | undefined) => void;

  /**
   * 前回表示した街区IDをセッションに保存
   * @param id
   */
  setSelectedDivisionId: (id: number) => void;

  /**
   * 前回表示したフロアグループIDをセッションに保存
   * @param id
   */
  setSelectedFloorGroupId: (id: number) => void;

  /**
   * 前回表示したフロアIDをセッションに保存
   * @param id
   */
  setSelectedFloorId: (id: number) => void;
};

/**
 * セッション情報 状態とアクションを管理するための DI コンテキスト
 */
export type SessionStore = SessionState & Action;

/**
 * セッション情報 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, useSession] = createDI<SessionStore>();
export { Provider as SessionStoreProvider, useSession as useSessionStore };

/**
 * 会社情報取得
 * @param loginInfo
 */
export const getCompany = (loginInfo: LoginReponse): Company => {
  return loginInfo.user.company ?? { id: 0, companyName: '不明', businessType: BusinessTypeKeys.none, defaultDivision: 0 };
};

/**
 * ユーザ名取得
 * @param loginInfo
 */
export const getUserName = (loginInfo: LoginReponse) => {
  return loginInfo.user.name;
};
